import React from "react";
import Form from "react-bootstrap/Form";
// import {
//   InputBoxComponent,
//   TextAreaReusableComponent,
// } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import SimpleReactLightbox from "simple-react-lightbox";
import classnames from "classnames";
import SingleImageReusableComponent from "../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";
import { InputCharacterCheck } from "../../../../function/InputCharNumCheckFunc";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import isEmpty from "../../../../store/validation/is-Empty";
import countryJson from "../../../localization/country.json";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

const RestaurantChainAddComponent = ({ localProps, state, ...props }) => {
  return (
    <div className="restaurant_chains_onboarding_main">
      <Form noValidate>
        <div className="col-md-6 pl-0">
          <NewInputText
            name="suggestlocation_code"
            inputType="text"
            onChange={localProps.onChangeHandler}
            onFocusOut={localProps.onFocusOut}
            value={state.suggestlocation_code}
            labelText="Location Code"
            helpTextDisplay={true}
            helperTextBottom="Enter your Location Code if any"
            controlClass={"outlined-helperText"}
          />
        </div>
        <div className="col-12 p-0">
          <h4 className="font_24_b mb-1">Business Chain Details</h4>
          <p className="font_16_r c_gray">
            Please enter details about your Business chain
          </p>
        </div>
        <div className="col-12 p-0">
          <NewInputText
            extraClass="mb-0 mt-4"
            name="title"
            inputType="text"
            onChange={localProps.onChangeHandler}
            onFocusOut={localProps.onFocusOut}
            value={state.title}
            errorText={state.errors.title}
            errorTrue={
              state.errors.title ===
              "*Fields can’t be blank. Please enter your title"
                ? true
                : false
            }
            labelText="Restaurant Chain Name"
            helpTextDisplay={true}
            helperTextBottom="Enter Name As It Appears On Your Store Front - Required Info"
            controlClass={
              state.errors.title ===
              "*Fields can’t be blank. Please enter your title"
                ? "outlined-error-helper-text"
                : "outlined-helperText "
            }
          />
        </div>
        <div className="col-12 p-0 text-area-labelText-padding">
          <NewInputText
            extraClass="mb-0 mt-4 text-area-labelText-padding-two"
            onChange={localProps.onChangeHandler}
            onFocusOut={localProps.onFocusOut}
            name="address"
            value={state.address}
            errorText={state.errors.address}
            errorTrue={
              state.errors.address ===
              "*Fields can’t be blank. Please enter your address"
                ? true
                : false
            }
            rows="4"
            multiline={true}
            labelText="Head Office Address"
            helpTextDisplay={true}
            helperTextBottom="Street Address - Required Info enter Name As It Appears On Your Store Front - Required Info"
            controlClass={
              state.errors.address ===
              "*Fields can’t be blank. Please enter your address"
                ? "outlined-error-helper-text"
                : "outlined-helperText "
            }
          />
        </div>
        <div className="col-12 p-0">
          <div className="row">
            <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
              <NewInputText
                extraClass="mb-0 mt-4"
                name="area"
                inputType="text"
                onChange={localProps.onChangeHandler}
                onFocusOut={localProps.onFocusOut}
                onKeyDown={InputCharacterCheck}
                value={state.area}
                errorText={state.errors.area}
                errorTrue={
                  state.errors.area ===
                  "*Fields can’t be blank. Please enter your area"
                    ? true
                    : false
                }
                labelText="Area"
                controlClass={
                  state.errors.area ===
                  "*Fields can’t be blank. Please enter your area"
                    ? "outlined-error-helper-text"
                    : "outlined-helperText "
                }
              />
            </div>
            <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
              <NewInputText
                extraClass="mb-0 mt-4"
                name="city"
                inputType="text"
                onChange={localProps.onChangeHandler}
                onFocusOut={localProps.onFocusOut}
                onKeyDown={InputCharacterCheck}
                value={state.city}
                errorText={state.errors.city}
                errorTrue={
                  state.errors.city ===
                  "*Fields can’t be blank. Please enter your city"
                    ? true
                    : false
                }
                labelText="City"
                controlClass={
                  state.errors.city ===
                  "*Fields can’t be blank. Please enter your city"
                    ? "outlined-error-helper-text"
                    : "outlined-helperText "
                }
              />
            </div>
            <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
              <NewInputText
                extraClass="mb-0 mt-4"
                name="pinCode"
                inputType="number"
                maxLength={
                  countryJson[state.localizationText] &&
                  countryJson[state.localizationText].pinCode
                }
                onChange={localProps.onChangeHandler}
                onFocusOut={localProps.onFocusOut}
                onKeyDown={InputNumberFunc}
                value={state.pinCode}
                errorText={state.errors.pinCode}
                errorTrue={state.errors.pinCode === "" ? true : false}
                labelText="Pin/Zip Code"
                controlClass={
                  state.errors.pinCode !== ""
                    ? "outlined-error-helper-text"
                    : "outlined-number"
                }
              />
            </div>
          </div>
        </div>
        <div className="mt-4"></div>
        {/* <Form.Label className="col-12 p-0 restaurant_details_onboarding_mobile_number mt-4">
          Email
        </Form.Label> */}
        {state.enquiry_emails.map((email, index) => (
          <div className="row mb-4 align-items-center" key={index}>
            <div className="col-9">
              <NewInputText
                extraClass="mb-0"
                name="email"
                inputType="email"
                onChange={localProps.onEmailChangeHandler(index)}
                onFocusOut={localProps.onFocusOut}
                value={email}
                errorText={
                  !validEmailRegex.test(email) && !isEmpty(email)
                    ? "Please enter a valid email"
                    : null ||
                      (email === "" &&
                      state.errors.email === "email is required"
                        ? "*Fields can’t be blank. Please enter your Email"
                        : null) ||
                      (email === "" &&
                        state.errors.email ===
                          "*Fields can’t be blank. Please enter your email")
                    ? "*Fields can’t be blank. Please enter your Email"
                    : ""
                }
                errorTrue={
                  (!validEmailRegex.test(email) && !isEmpty(email)) ||
                  (email === "" &&
                    state.errors.email === "email is required") ||
                  (email === "" &&
                    state.errors.email ===
                      "*Fields can’t be blank. Please enter your email")
                    ? true
                    : false
                }
                labelText="Enquiry Email"
                controlClass={
                  (!validEmailRegex.test(email) && !isEmpty(email)) ||
                  (email === "" &&
                    state.errors.email === "email is required") ||
                  (email === "" &&
                    state.errors.email ===
                      "*Fields can’t be blank. Please enter your email")
                    ? "outlined-error-helper-text"
                    : "outlined-helperText"
                }
              />
            </div>
            <div className="col-3 pr-0 restaurant_details_onboarding_minus_button">
              {state.enquiry_emails.length > 1 ? (
                <div>
                  <AddButtonIconComponent
                    buttonText="Delete"
                    onClick={localProps.onEmailPhoneAddDeleteHandler(
                      "email",
                      "delete",
                      index
                    )}
                    fontIcon="fa fa-trash-o"
                    colorCss="delete"
                  />
                </div>
              ) : (
                <div>
                  <AddButtonIconComponent
                    buttonText="Add Another"
                    onClick={localProps.onEmailPhoneAddDeleteHandler(
                      "email",
                      "add"
                      // AREA
                    )}
                    fontIcon="fa fa-plus"
                    colorCss="blue"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
        {state.enquiry_emails.length > 1 ? (
          <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button">
            <div>
              <AddButtonIconComponent
                buttonText="Add Another Email"
                onClick={localProps.onEmailPhoneAddDeleteHandler(
                  "email",
                  "add"
                  // AREA
                )}
                fontIcon="fa fa-plus"
                colorCss="blue"
              />
            </div>
          </div>
        ) : null}

        {/* <Form.Label className="col-12 mt-3 pl-0 restaurant_details_onboarding_mobile_number">
          Mobile Number
        </Form.Label> */}
        {state.phone_numbers.map((phone, index) => (
          <div className="row mb-4 align-items-center" key={index}>
            <div className="col-4 col-xl-3">
              <Form.Group
                className="reusableInputComponent-main mb-0"
                controlId={"country_code"}
              >
                <div className="input-phone-country-code-reusable">
                  <select
                    name="country_code"
                    value={phone.country_code}
                    onChange={localProps.onPhoneDataChangeHandler(
                      "country_code",
                      index
                    )}
                  >
                    <option
                      value={
                        phone.country_code === ""
                          ? state.country_code
                          : phone.country_code
                      }
                    >
                      {phone.country_code === ""
                        ? state.country_code
                        : phone.country_code}
                    </option>
                    {getCountries().map((country) => (
                      <option
                        key={country}
                        value={"+" + getCountryCallingCode(country)}
                        // onClick={this.onChangeCountry}
                      >
                        {en[country]} (+
                        {getCountryCallingCode(country)})
                      </option>
                    ))}
                  </select>
                </div>
              </Form.Group>
            </div>
            <div className="col-5 col-xl-6 pl-0">
              <NewInputText
                extraClass="mb-0"
                name="mobile_no"
                inputType="number"
                onFocusOut={localProps.onFocusOut}
                onChange={localProps.onPhoneDataChangeHandler(
                  "mobile_no",
                  index
                )}
                value={phone.mobile_no}
                maxLength="10"
                onKeyDown={InputNumberFunc}
                errorText={
                  phone.mobile_no === "" &&
                  state.errors.mobile_no === "phone number is required"
                    ? "*Fields can’t be blank. Please enter your valid mobile number"
                    : null ||
                      (phone.mobile_no === "" &&
                        state.errors.mobile_no ===
                          "*Fields can’t be blank. Please enter your mobile_no")
                    ? "*Fields can’t be blank. Please enter your valid mobile number"
                    : null ||
                      (phone.mobile_no.length > 0 &&
                        phone.mobile_no.length <= 9)
                    ? "Enter your valid mobile number"
                    : null
                }
                errorTrue={
                  (phone.mobile_no === "" &&
                    state.errors.mobile_no ===
                      "*Fields can’t be blank. Please enter your mobile_no") ||
                  (phone.mobile_no === "" &&
                    state.errors.mobile_no === "phone number is required") ||
                  (phone.mobile_no.length > 0 && phone.mobile_no.length <= 9)
                    ? true
                    : false
                }
                labelText="Phone Number*"
                controlClass={
                  (phone.mobile_no === "" &&
                    state.errors.mobile_no ===
                      "*Fields can’t be blank. Please enter your mobile_no") ||
                  (phone.mobile_no === "" &&
                    state.errors.mobile_no === "phone number is required") ||
                  (phone.mobile_no.length > 0 && phone.mobile_no.length <= 9)
                    ? "outlined-error-helper-text"
                    : "outlined-helperText"
                }
              />
              {/* <InputBoxComponent
                displayLabel={false}
                controlId="phone"
                placeHolder="eg. 9898989898*"
                name="phone"
                inputType="number"
                onChange={localProps.onPhoneDataChangeHandler(
                  "mobile_no",
                  index
                )}
                onFocusOut={localProps.onFocusOut}
                maxLength="10"
                value={phone.mobile_no}
                onKeyDown={InputNumberFunc}
                required="required"
                // error={errors.mobileNumber}
                // showBottom={true}
                error={
                  phone.mobile_no.length > 0 && phone.mobile_no.length <= 9
                    ? "Enter valid Mobile Number"
                    : state.errors.phone_numbers || phone.mobile_no.length <= 0
                    ? state.errors.phone
                    : ""
                }
                inputClassName={classnames("input-component-inputfield", {
                  invalid: state.errors.phone_numbers,
                })}
              />
              <Form.Text className="text-muted input-component-bottom position-absolute">
                <div className="text-danger text-capitalize">
                  {phone.mobile_no === "" ? state.phoneError.phone : ""}
                </div>
              </Form.Text> */}
            </div>

            <div className="col-3 restaurant_details_onboarding_minus_button">
              {state.phone_numbers.length > 1 ? (
                <div>
                  <AddButtonIconComponent
                    buttonText="Delete"
                    onClick={localProps.onEmailPhoneAddDeleteHandler(
                      "phone",
                      "delete",
                      index
                    )}
                    fontIcon="fa fa-trash-o"
                    colorCss="delete"
                  />
                </div>
              ) : (
                <div>
                  <AddButtonIconComponent
                    buttonText="Add Another"
                    onClick={localProps.onEmailPhoneAddDeleteHandler(
                      "phone",
                      "add"
                      // AREA
                    )}
                    fontIcon="fa fa-plus"
                    colorCss="blue"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
        {state.phone_numbers.length > 1 ? (
          <div className="col-12 p-0 mt-3 restaurant_details_onboarding_minus_button add_email_button">
            <div>
              <AddButtonIconComponent
                buttonText="Add Another Phone Number"
                onClick={localProps.onEmailPhoneAddDeleteHandler(
                  "phone",
                  "add"
                  // AREA
                )}
                fontIcon="fa fa-plus"
                colorCss="blue"
              />
            </div>
          </div>
        ) : null}
        <div className="col-12 p-0 margin-bottom-chains-onboarding mb-5">
          <SimpleReactLightbox>
            <SingleImageReusableComponent
              title="Add Logo*"
              // onDrop={localProps.onSingleImageDrop}
              onChange={localProps.onImageLogoUploadHandler}
              combined={state.combined && state.combined}
              onCompleteCrop={localProps.onCompleteCrop}
              onCancelCrop={localProps.onCancelCrop}
              file={
                (state.logo_main &&
                  state.logo_main !== null &&
                  state.logo_main) ||
                (state.icon && state.icon)
              }
              // file={state.icon}
              resetFile={localProps.removeFile}
              name="addOffer"
              error={state.errors.icon}
            />
          </SimpleReactLightbox>
          <div className="opacity5 f9-400">
            Only .jpg and .png files. 500kb max file size
          </div>
        </div>
      </Form>
    </div>
  );
};

export default RestaurantChainAddComponent;
